import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useStore } from "vuex";
import ReservationForm from "@/components/shared/ReservationForm.vue";
import { useI18n } from "vue-i18n";
import { useToast } from "primevue/usetoast";
import { useRouter } from "vue-router";
import { DateTimeToISOString } from "@/assets/utils/date";
import { useNotify } from "@/composables/useNotify";


export default /*#__PURE__*/_defineComponent({
  __name: 'add',
  setup(__props) {

const router = useRouter();
const toast = useToast();
const store = useStore();
const { t } = useI18n();
const { successToast, errorToast } = useNotify({ t });
const addReservation = async ({ reservation, notifyClient }) => {
  try {
    await store.dispatch("reservation/CREATE_RESERVATION", {
      reservation,
      notifyClient,
    });
    successToast({ title: t("reservation"), detail: t("createdSuccessfully") });

    const startDate = DateTimeToISOString(new Date(reservation.at));
    router.replace({ name: "ReservationList", query: { startDate } });
  } catch (e: any) {
    errorToast({ title: t("error"), error: e?.message });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ReservationForm, { onSave: addReservation }))
}
}

})